import { useZones } from 'zens-store'

const useFloorZoneIds = (companyId: number, floorId: number) => {
  const zones = useZones({ companyId, floorId }, { enabled: !!floorId })
  return floorId ? (zones.data || []).map((zone) => zone.id) : []
}

export default useFloorZoneIds
